import { useEffect, useState } from 'react';
import { createContainer } from 'unstated-next';
import { setVariableFlatMenu } from './utils/globalVariable';
import { IPropsRouter } from './type';

interface IUseMenuState {
    appId: number;
    router: any;
}

interface INotVerifyFlatMenus extends IPropsRouter {
    url: string;
}

declare const window: any;

function useMenuState(props: IUseMenuState = { appId: 0, router: [] }) {
    const [flatMenu, setFlatMenu] = useState({});
    const [authRouter, setAuthRouter] = useState([]);
    const [visibleMenu, setVisibleMenu] = useState([]);
    const [router] = useState(props.router);
    const [menuCollapsed, setMenuCollapsed] = useState(false);
    const [breadMenu, setBreadMenu] = useState([]);
    const [flatOriginRouter, setFlatOriginRouter] = useState({});
    const [loading, setLoading] = useState(false);
    const [notExist, setNotExist] = useState<React.ReactNode>();
    const [noPermission, setNnoPermission] = useState<React.ReactNode>();
    const [notVerifyFlatMenus, setNotVerifyFlatMenus] = useState<INotVerifyFlatMenus[]>([]);
    useEffect(() => {
        setVariableFlatMenu(flatMenu);
    }, [flatMenu]);

    return {
        flatMenu,
        authRouter,
        router,
        menuCollapsed,
        loading,
        visibleMenu,
        breadMenu,
        flatOriginRouter,
        notExist,
        noPermission,
        notVerifyFlatMenus,
        setNnoPermission,
        setNotExist,
        setVisibleMenu,
        setLoading,
        setFlatMenu,
        setFlatOriginRouter,
        setBreadMenu,
        setAuthRouter,
        setMenuCollapsed,
        setNotVerifyFlatMenus,
    };
}

const MenuState = createContainer<ReturnType<typeof useMenuState>, IUseMenuState>(useMenuState);

export { useMenuState };
export default MenuState;
